import Helping from "../helpers/Helping";
import { MESSAGE } from '../config/index';
import { API_URL } from '../config/urls';
import { USER_LIST } from '../config/routes';
import Service from '../helpers/service';
import { editUserIsEnabled, editUserIsConfirmed, editUserIsDeleted, fetchUser, destroyUser } from "../actions/user_action";
import { fetchUserMeta } from "../actions/user_meta_action";
import { trackPromise } from 'react-promise-tracker';
const { SENT_FAILED, DELETE } = MESSAGE;

let updateCallback = (res) => {

}

export const setUserError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type, startDate, endDate, status, isConfirmed, username="", email="", pub_key="") => {
    let apiUrl = "http://3.92.133.203:4000/admin/"
    // let apiUrl = API_URL.ADMIN_API
  return dispatch => {
    trackPromise(
      Service.getCall(
          apiUrl + USER_LIST +
        "?page=" +
        page +
        "&limit=" +
        limit +
        "&search=" +
        search.trim() +
        "&sorting=" +
        sorting +
        "&sort_type=" +
        sort_type +
        "&startDate=" +
        Helping.formatDateInYearMonthDay(startDate) +
        "&endDate=" +
        Helping.formatDateInYearMonthDay(endDate) +
        "&role=user"+
        "&isEnable=" +
        status +
        "&isConfirmed=" +
        isConfirmed +
        "&username=" +
        username +
        "&email=" +
        email +
        "&pub_key=" +
        pub_key
      )
        .then(response => {
          let total = response.data.payload.total;
          dispatch(fetchUser(response.data.payload.users));
          return dispatch(
            fetchUserMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              start_date: startDate,
              end_date: endDate,
              status: status,
              confirmed: isConfirmed,
              username: username,
              email: email,
              pub_key: pub_key,
              total: total,
              users: response.data.payload.users,
              count: response.data.payload.count,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);

          dispatch(fetchUser([]));
          dispatch(
            fetchUserMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              start_date: startDate,
              end_date: endDate,
              status: status,
              confirmed: isConfirmed,
              username: username,
              email: email,
              pub_key: pub_key,
              total: 0,
              users: 0,
              count: 0,
              no_Of_pages: page
            })
          );
          if (error.response) {
            Helping.redirectToLogin(error);
            return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
          }
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching users")
          })
        })
    )

  };
};

export const updateIsEnabled = (data, status, callback) => {
  return dispatch => {
    Service.putCall(
      API_URL.ADMIN_API + "admin/user/" + data.id,
      { isEnable: status }
    )
      .then(response => {
        dispatch(editUserIsEnabled(data.id, status));
        callback();
      })
      .catch(error => {
        console.log("error while updating user isEnable status: ", error);
        if (error.response) {
          Helping.redirectToLogin(error);
          return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
        }
        return updateCallback({
          ...Helping.setNetworkRequestError(error, status ? "enabling user" : "disabling user")
        })
      });
  };
};

export const updateUserStatus = (id) => {
  return dispatch => {

    trackPromise(
      Service.postCall(
        API_URL.ADMIN_TRADING_API + "user-activation-link", { id }
      )
        .then(response => {
          return updateCallback({
            error_message: response.data.message,
            error_type: 'success'
          });
        })
        .catch(error => {
          console.log("error while updating user isEnable status: ", error.response);
          if (error.response) {
            Helping.redirectToLogin(error);
            return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
          }
          return updateCallback({
            ...Helping.setNetworkRequestError(error, Helping.getMessageString(SENT_FAILED, "verification email"))
          })
        })
    )
  };
};

export const updateIsConfirmed = (data, status, callback) => {
  return dispatch => {
    Service.putCall(
      API_URL.ADMIN_API + "admin/user/" + data.id,
      { isConfirmed: status }
    )
      .then(response => {
        callback();
        dispatch(editUserIsConfirmed(data.id, status));
      })
      .catch(error => {
        console.log("error while updating user status isConfirmed: ", error);
        if (error.response) {
          Helping.redirectToLogin(error);
          return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
        }
        return updateCallback({
          ...Helping.setNetworkRequestError(error, status ? "confirming user" : "canceling confirmation of user")
        })
      });
  };
};

export const updateIsDeleted = (data, deleted, callback) => {
  return dispatch => {
    Service.putCall(
      API_URL.ADMIN_API + "admin/user/" + data.id,
      { is_deleted: deleted }
    )
      .then(response => {
        callback();
        dispatch(editUserIsDeleted(data.id, deleted));

        return updateCallback({
          error_message: deleted ? Helping.getMessageString(DELETE, "User") : response.data.message,
          error_type: 'success',
        });
      })
      .catch(error => {
        console.log("error while updating user status is_deleted: ", error);
        if (error.response) {
          Helping.redirectToLogin(error);
          return updateCallback({ error_message: error.response.data.message, error_type: 'danger' });
        }
        return updateCallback({
          ...Helping.setNetworkRequestError(error, deleted ? "deleting user" : "cancelling deletion of user")
        })
      });
  };
};

export const destroy = key => {
  return dispatch => dispatch(destroyUser(key));
}